/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
// import "./layout.css"

const Layout = ({ children }) => {

  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
        }
      }
      allPubliJson {
        edges {
          node {
            title
            url
          }
        }
      }
    }
  `);

  const publi = data.allPubliJson.edges.map((item) => item.node);

  publi.sort(() => Math.random() - 0.5);
  
  const ads = publi.slice(0, 4);

  return (
    <div className="flex">

      <div className="" style={{ flexBasis: '0px' }}>

      </div>

      <div className="flex-1">

        <Header {...data.site.siteMetadata} />
        <main className="container mx-auto my-2 sm:my-8 md:flex">
          <div className="flex-1 p-4">
            {children}
          </div>
          <div className="flex-none t-8 ml-8">
            <div className="text-sm text-gray-500 mb-4 text-center">Publicidade</div>
            {ads.map((item) => (
              <div className="flex justify-center p-4">
                <iframe title={item.title} style={{ width: '120px', height: '240px ' }} marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src={item.url}>
                </iframe>
              </div>
            ))}
          </div>
        </main>
        <footer className="bg-green-800 p-4 h-32 flex justify-center items-center text-white">

          <div className="text-center">
            Taxas do Tesouro © {new Date().getFullYear()}
          </div>
          {/* <div className="mx-2"> &middot;</div>
          <div>
            <a href="mailto:contato@taxas-tesouro.com">contato@taxas-tesouro.com</a>
          </div> */}
          <div className="mx-2"> &middot;</div>
          <div className="text-center">
            <a href="mailto:jordi@serrano.solutions">Desenvolvido por SERRANO SOLUTIONS</a>
          </div>
        </footer>
      </div>

    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
